import {InputType} from "module/CustomField/util/CFInputType";
import React, {useCallback} from 'react';
import {CFComponentProps} from 'module/CustomField/type/CFComponentType';
import {CFValue} from 'module/CustomField/type/CFType';
import {useDqSearchRx} from 'module/Slct/impl/hook/useDqSearchRx'
import {useMemoParams} from 'module/Memo/hook/useMemoDq'
import {Slct} from 'module/Slct/component/Slct'
import {filterOptionsSlct} from 'module/Slct/util/filterOptionsSlct'
import {SlctOnChangeState, SlctOption} from 'module/Slct/type/SlctType'
import {cssCFSlct} from 'module/CustomField/style/cssCFInput'
import {getCFAttrTextAlign} from 'module/CustomField/style/CFAlignmentStyle'
import {SetCb} from 'type/SetCb'
import {useSlctCFAttrs} from 'module/Slct/hook/useSlctCFAttrs'
import {isDqSearchable} from 'module/Dq/util/DqParser'
import {TextAlign} from 'type/TextAlign'

export interface CustomFieldSelectComponentCustomProps extends CFComponentProps<CFValue> {
	align?: TextAlign
}

export const CustomFieldSelectComponent = React.memo(function CustomFieldSelectComponent<ModelType extends object | void, ValueType extends string | number>(
	props: CustomFieldSelectComponentCustomProps,
) {
	const {
		cfDef,
		pos,
		setCb,
		setAzeText,
		model,
		modelValue,
		disabled,
		placeholderHTML,
		align,
	} = props

	const {
		searchSubject,
		suggestions,
		byValueCache,
		loading,
	} = useDqSearchRx(props)
	const options = suggestions as SlctOption<ModelType, ValueType>[]
	const memoParams = useMemoParams(cfDef)
	let inputType = InputType[cfDef.input as InputType || InputType.String]
	const isSelect = InputType.Dq === inputType
	const {menuWidth, displayFormat} = useSlctCFAttrs(cfDef)

	const onChangeState = useCallback<SlctOnChangeState>(({focus, inputValue}) => {
		if (focus) {
			searchSubject.next({searchTerm: inputValue === (modelValue + '') ? '' : inputValue, model})
		} else {
			searchSubject.next({searchTerm: '', model})
		}
	}, [searchSubject, model])

	const onChange: SetCb<SlctOption<ModelType, ValueType> | null> = useCallback((x) => {
		setCb(x?.value)
		if (x?.azetext && setAzeText) {
			setAzeText({bookingNr: model.bookingNr, azetext: x.azetext})
		}
	}, [setCb, model.bookingNr, setAzeText])

	return (
		<div className={'CustomFieldSelectComponent'} css={cssCFSlct}>
			<Slct
				disabled={disabled}
				placeholderHTML={placeholderHTML}
				options={options}
				byValueCache={byValueCache}
				loading={loading}
				value={!modelValue && modelValue !== 0 ? null : modelValue}
				onChange={onChange}
				onChangeState={onChangeState}
				filterOptions={isDqSearchable(cfDef.dqKey) ? undefined : filterOptionsSlct}
				memo={memoParams}
				menuIsOpen={isSelect ? undefined : false}
				displayFormat={displayFormat}
				menuWidth={menuWidth}
				align={getCFAttrTextAlign(cfDef) || align}
			/>
		</div>
	)
})